import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect } from 'react-router-dom';
import { getInt } from 'utils/functions';
import DocumentPropertiesContainer from 'features/document/edit/documentProperties/components/DocumentPropertiesContainer';
import DocumentVerificationContainer from '../../../document/edit/verification/components/DocumentVerificationContainer';
import StateTransitionsContainer from 'features/document/edit/stateTransitions/components/StateTransitionsContainer';
import DocumentComments from 'features/offer/edit/sidebar/components/comments/DocumentComments';
import documentTypeIds from 'constants/documentTypeIds';
import WrappedFakeText from 'components/common/WrappedFakeText';

const FacilitySwitcher = ({
  facilityGeneralDataContainer,
  facilitySublimitsContainer,
  facilityKpiIndicatorsContainer,
  createFacilityContainer,
  history
}) => (
  <Switch>
    <Route exact path='/facilities/:documentId(\d+)/:siteId(\d+)' render={() => <WrappedFakeText onPaper />} />
    <Route exact path='/facilities/new' render={createFacilityContainer} />
    <Route exact path='/facilities/:documentId(\d+)/:siteId(\d+)/generalData' render={facilityGeneralDataContainer} />
    <Route exact path='/facilities/:documentId(\d+)/:siteId(\d+)/sublimits' render={facilitySublimitsContainer} />
    <Route exact path='/facilities/:documentId(\d+)/:siteId(\d+)/kpiIndicators' render={facilityKpiIndicatorsContainer} />
    <Route
      exact
      path='/facilities/:documentId(\d+)/:siteId(\d+)/verifications'
      render={route => (
        <DocumentVerificationContainer documentId={getInt(route.match.params.documentId)} siteId={getInt(route.match.params.siteId)} />
      )}
    />
    <Route
      exact
      path='/facilities/:documentId(\d+)/:siteId(\d+)/document-properties'
      render={route => (
        <DocumentPropertiesContainer documentId={getInt(route.match.params.documentId)} siteId={getInt(route.match.params.siteId)} />
      )}
    />
    <Route
      exact
      path='/facilities/:documentId(\d+)/:siteId(\d+)/state-transitions'
      render={route => (
        <StateTransitionsContainer
          documentId={getInt(route.match.params.documentId)}
          siteId={getInt(route.match.params.siteId)}
          documentTypeId={documentTypeIds.Facility}
        />
      )}
    />
    <Route
      exact
      path='/facilities/:documentId(\d+)/:siteId(\d+)/comments'
      render={route => (
        <DocumentComments
          documentId={getInt(route.match.params.documentId)}
          siteId={getInt(route.match.params.siteId)}
          history={history}
          fullScreen={true}
        />
      )}
    />
    <Route render={() => <Redirect to='/notFound' />} />
  </Switch>
);

FacilitySwitcher.propTypes = {
  facilityGeneralDataContainer: PropTypes.func.isRequired,
  facilitySublimitsContainer: PropTypes.func.isRequired,
  facilityKpiIndicatorsContainer: PropTypes.func.isRequired,
  createFacilityContainer: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired
};

export default FacilitySwitcher;
